import {inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from './auth.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor
{
    private auth = inject(AuthService);
    private router = inject(Router);
    private locale = inject(LOCALE_ID);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
      if (!this.auth.accessToken) {
          return next.handle(req);
      }

      const newRequest = req.clone({
          headers: req.headers.append('AISAuth', this.auth.accessToken),
          params: req.params.append('lng', this.locale.slice(0, 2).toUpperCase())
      });

      return next.handle(newRequest)
          .pipe(
              catchError((error: any) => {
                  if (error instanceof HttpErrorResponse) {
                      if (error.status === 401) {
                          this.router.navigate(['/auth-error']);
                      }
                      if (error.status === 500) {
                          console.log(error);
                      }
                  }

                  throw error;
              })
          );
  }

}
